import postRequest from '../../../../../postRequest';

/**
 * Calls styles endpoint to get existing sites.
 *
 * @param {number} productId - 15974689
 * @param {string} siteCode - JD
 * @returns {Promise} { data: { Data: [{}], Pagination: {} }, status: 200 }
 */
async function postStyles(productId, siteCode) {
  const endpoint = '/integration-pim/v1/products/drop-shipment/styles';

  const body = {
    productId,
    siteCode,
  };
  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Styles')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default postStyles;
